import configHelper from '@/config/ConfigHelper'
import { i18n } from '@/i18n'

function GenerateConfig () {
  return [
    {
      id: '01',
      name: i18n.t('tipos.measurement_units.units'),
    },
    {
      id: '02',
      name: i18n.t('tipos.measurement_units.hur'),
    },
    {
      id: '03',
      name: i18n.t('tipos.measurement_units.kgm'),
    },
    {
      id: '04',
      name: i18n.t('tipos.measurement_units.ltr'),
    },
    {
      id: '05',
      name: i18n.t('tipos.measurement_units.otros'),
    },
    {
      id: '06',
      name: i18n.t('tipos.measurement_units.bx'),
    },
    {
      id: '07',
      name: i18n.t('tipos.measurement_units.ds'),
    },
    {
      id: '08',
      name: i18n.t('tipos.measurement_units.ba'),
    },
    {
      id: '09',
      name: i18n.t('tipos.measurement_units.jy'),
    },
    {
      id: '10',
      name: i18n.t('tipos.measurement_units.bg'),
    },
    {
      id: '11',
      name: i18n.t('tipos.measurement_units.co'),
    },
    {
      id: '12',
      name: i18n.t('tipos.measurement_units.bo'),
    },
    {
      id: '13',
      name: i18n.t('tipos.measurement_units.ci'),
    },
    {
      id: '14',
      name: i18n.t('tipos.measurement_units.briks'),
    },
    {
      id: '15',
      name: i18n.t('tipos.measurement_units.clt'),
    },
    {
      id: '16',
      name: i18n.t('tipos.measurement_units.cmt'),
    },
    {
      id: '17',
      name: i18n.t('tipos.measurement_units.bi'),
    },
    {
      id: '18',
      name: i18n.t('tipos.measurement_units.docenas'),
    },
    {
      id: '19',
      name: i18n.t('tipos.measurement_units.cs'),
    },
    {
      id: '20',
      name: i18n.t('tipos.measurement_units.dj'),
    },
    {
      id: '21',
      name: i18n.t('tipos.measurement_units.grm'),
    },
    {
      id: '22',
      name: i18n.t('tipos.measurement_units.kmt'),
    },
    {
      id: '23',
      name: i18n.t('tipos.measurement_units.ca'),
    },
    {
      id: '24',
      name: i18n.t('tipos.measurement_units.bh'),
    },
    {
      id: '25',
      name: i18n.t('tipos.measurement_units.mtr'),
    },
    {
      id: '26',
      name: i18n.t('tipos.measurement_units.mmt'),
    },
    {
      id: '27',
      name: i18n.t('tipos.measurement_units.packs'),
    },
    {
      id: '28',
      name: i18n.t('tipos.measurement_units.pk'),
    },
    {
      id: '29',
      name: i18n.t('tipos.measurement_units.raciones'),
    },
    {
      id: '30',
      name: i18n.t('tipos.measurement_units.ro'),
    },
    {
      id: '31',
      name: i18n.t('tipos.measurement_units.en'),
    },
    {
      id: '32',
      name: i18n.t('tipos.measurement_units.tb'),
    },
    {
      id: '33',
      name: i18n.t('tipos.measurement_units.mtq'),
    },
    {
      id: '34',
      name: i18n.t('tipos.measurement_units.sec'),
    },
    {
      id: '35',
      name: i18n.t('tipos.measurement_units.wtt'),
    },
    {
      id: '36',
      name: i18n.t('tipos.measurement_units.kwh'),
    },
  ]
}

export function TIPOS_UNIDADES_MEDIDA (state) {
  return configHelper.getConfig(state, 'TIPOS_UNIDADES_MEDIDA', GenerateConfig)
}
